import { render, staticRenderFns } from "./SafeLogs.vue?vue&type=template&id=27faaae9&scoped=true"
import script from "./SafeLogs.vue?vue&type=script&lang=js"
export * from "./SafeLogs.vue?vue&type=script&lang=js"
import style0 from "./SafeLogs.vue?vue&type=style&index=0&id=27faaae9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27faaae9",
  null
  
)

export default component.exports